import {
  HubBranding,
  HubBrandingUpdateInput,
  HubCreateRequest,
  HubCreateResult,
} from '@vivport/backend/types';
import { httpClient } from './http-client';
import { executeTool, ExecuteToolResponse } from './tools-api';

/**
 * Hub API
 * Type-safe wrappers for hub operations
 * @requires Authentication
 */

/**
 * Create a new Corporate Hub owned by the authenticated account
 */
export async function createHub(input: HubCreateRequest): Promise<HubCreateResult> {
  return httpClient.post<HubCreateResult, HubCreateRequest>('/protected/hubs', input);
}

/**
 * Read the current hub's letterhead branding fields
 */
export async function getHubBranding(): Promise<HubBranding> {
  return httpClient.get<HubBranding>('/protected/hubs/branding');
}

/**
 * Update the current hub's letterhead branding through the governed tool
 */
export async function updateHubBranding(
  input: HubBrandingUpdateInput
): Promise<ExecuteToolResponse<HubBranding>> {
  return executeTool<HubBrandingUpdateInput, HubBranding>('platform.updateHubBranding', input);
}
